// {
//     groupId : "g1687186319821",
//     NumOpts : 1,
//     min_to_comp : 1,
//     task:[],
//     event:[]
// }
import { generateUUID } from "../../components/helpers/uuidgenerator";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Trash2 } from "lucide-react";

export const Group = ({ groupItem, formStates, setFormStates, i, j }) => {
  const handleChange = (i, j, e) => {
    setFormStates((prev) => {
      let cArr = [...prev.challenge];
      let gArr = cArr[i].group;
      gArr[j] = { ...gArr[j], [e.target.name]: e.target.value };
      return { ...prev, challenge: [...cArr] };
    });
  };

  const deleteGroup = (i, j) => {
    if (groupItem.num_opts == 0) {
      setFormStates((prev) => {
        let cArr = [...prev.challenge];
        let gArr = [...cArr[i].group];
        let deletedObj = {
          ...prev.deleted,
          group: [...prev.deleted.group, gArr[j]],
        };
        gArr.splice(j, 1);
        cArr[i] = { ...cArr[i], group: [...gArr] };
        let newObj = { ...prev, challenge: [...cArr], deleted: deletedObj };
        return newObj;
      });
    }
  };

  return (
    <div id={j} className="space-y-4">
      <div className="flex justify-between items-center">
        <h5 className="text-lg font-semibold">Group no. {j + 1}</h5>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => deleteGroup(i, j)}
        >
          <Trash2 className="h-4 w-4 text-red-600" />
        </Button>
      </div>

      <div>
        <Label htmlFor={`group_name_${i}_${j}`}>Group Name</Label>
        <Input
          type="text"
          name="group_name"
          id={`group_name_${i}_${j}`}
          placeholder="Group Name"
          onChange={(e) => handleChange(i, j, e)}
          value={groupItem.group_name}
        />
      </div>

      <div>
        <p className="text-sm text-gray-600">
          Number of options: <span className="font-semibold">{groupItem.num_opts}</span>
        </p>
      </div>

      <div>
        <Label htmlFor={`min_to_comp_${i}_${j}`}>Minimum to Complete</Label>
        <Input
          type="number"
          name="min_to_comp"
          id={`min_to_comp_${i}_${j}`}
          min="0"
          max={groupItem.num_opts}
          placeholder="Minimum to Comply"
          value={groupItem.min_to_comp}
          onChange={(e) => handleChange(i, j, e)}
        />
      </div>
    </div>
  );
};

export const groupObj = (timestamp) => {
  return {
    group_id: "g" + String(timestamp),
    group_name: "",
    num_opts: 0,
    min_to_comp: 0,
    task_ids: [],
    event_ids: [],
  };
};

export const addGroup = (i, setFormStates) => {
  setFormStates((prev) => {
    let chArr = [...prev.challenge];
    chArr[i] = {
      ...chArr[i],
      group: [...chArr[i].group, { ...groupObj(generateUUID()) }],
    };
    let newObj = { ...prev, challenge: [...chArr] };

    return newObj;
  });
};

//add task_ids into group arr
export const addTaskGroup = (i, j, setFormStates, task_id) => {
  setFormStates((prev) => {
    let cArr = [...prev.challenge];
    let gArr = [...cArr[i].group];
    let gObj = { ...gArr[j] };
    gObj = {
      ...gObj,
      num_opts: gObj.num_opts + 1,
      task_ids: [...gObj.task_ids, task_id],
    };
    gArr[j] = gObj;
    cArr[i] = { ...cArr[i], group: gArr };
    return { ...prev, challenge: [...cArr] };
  });
};

//add event_ids into group arr
export const addEventGroup = (i, j, setFormStates, event_id) => {
  setFormStates((prev) => {
    let cArr = [...prev.challenge];
    let gArr = [...cArr[i].group];
    let gObj = { ...gArr[j] };
    gObj = {
      ...gObj,
      num_opts: gObj.num_opts + 1,
      event_ids: [...gObj.event_ids, event_id],
    };
    gArr[j] = gObj;
    cArr[i] = { ...cArr[i], group: gArr };
    return { ...prev, challenge: [...cArr] };
  });
};

//delete task_ids from group arr
export const deleteTaskGroup = (i, group_id, setFormStates, task_id) => {
  setFormStates((prev) => {
    let cArr = [...prev.challenge];
    let gArr = [...cArr[i].group];
    let j;
    gArr.map((item, index) => {
      if ((item.group_id = group_id)) {
        j = index;
      }
    });
    let gObj = { ...gArr[j] };
    let taskIdsArr = [...gObj.task_ids];
    taskIdsArr = taskIdsArr.filter((id) => {
      if (id == task_id) {
        return false;
      } else {
        return true;
      }
    });
    gObj = { ...gObj, num_opts: gObj.num_opts - 1, task_ids: [...taskIdsArr] };
    gArr[j] = gObj;
    cArr[i] = { ...cArr[i], group: gArr };
    return { ...prev, challenge: [...cArr] };
  });
};

//delete event_ids from group arr
export const deleteEventGroup = (i, group_id, setFormStates, event_id) => {
  setFormStates((prev) => {
    let cArr = [...prev.challenge];
    let gArr = [...cArr[i].group];
    let j;
    gArr.map((item, index) => {
      if ((item.group_id = group_id)) {
        j = index;
      }
    });
    let gObj = { ...gArr[j] };
    let eventIdsArr = [...gObj.event_ids];
    eventIdsArr = eventIdsArr.filter((id) => {
      if (id == event_id) {
        return false;
      } else {
        return true;
      }
    });
    gObj = {
      ...gObj,
      num_opts: gObj.num_opts - 1,
      event_ids: [...eventIdsArr],
    };
    gArr[j] = gObj;
    cArr[i] = { ...cArr[i], group: gArr };
    return { ...prev, challenge: [...cArr] };
  });
};

export default Group;
